export const initialState = {
    showBackgroundImg: true
};

export function backgroundOptions(state = initialState, action) {
    if (action.type === "SHOW_BACKGROUND_IMG") {
        return {
            showBackgroundImg: action.showBackgroundImg
        };
    } else {
        return state;
    }
}
